import React, { useState, useEffect } from 'react';
import { ArrowUp } from 'lucide-react';

interface ScrollNavigatorProps {
  isHidden?: boolean;
}

export function ScrollNavigator({ isHidden }: ScrollNavigatorProps = {}) {
  const [isScrolledDown, setIsScrolledDown] = useState(false);

  useEffect(() => {
    let ticking = false;

    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const current = window.scrollY;
          const scrolledDown = current > 400;

          setIsScrolledDown(prev => (prev !== scrolledDown ? scrolledDown : prev));
          ticking = false;
        });
        ticking = true;
      }
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const isVisible = !isHidden && isScrolledDown;

  return (
    <div 
      className={`fixed bottom-5 left-5 z-40 transition-all duration-300 ${
        isVisible 
          ? 'opacity-100 translate-y-0 pointer-events-auto' 
          : 'opacity-0 translate-y-4 pointer-events-none'
      }`}
    >
      <button
        type="button"
        onClick={scrollToTop}
        className="px-3.5 py-2 bg-[#151819]/90 hover:bg-[#14B8A6] text-gray-300 hover:text-black border border-[#2A2F31] hover:border-[#14B8A6] rounded-full backdrop-blur-md transition-all active:scale-95 flex items-center gap-1.5 cursor-pointer shadow-xl text-xs font-semibold group"
        title="Back to Top"
        aria-label="Back to Top"
      >
        <ArrowUp size={14} className="text-[#14B8A6] group-hover:text-black transition-colors" />
        <span className="text-[11px] font-medium hidden sm:inline">Back to Top</span>
      </button>
    </div>
  );
}
